import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { TipoPaginadorEnum } from '@appNeo/neoShared/helpers/enums/TipoPaginador.enum';
import { Paginator } from '@app/shared/models/paginator/paginator';
import { TipoMedioContacto } from '@app/core/interfaces/tipo-medio-contacto';
import { AuxiliarService } from '@app/shared/services/auxiliar/auxiliar.service';
import { RespApi } from '@app/shared/helpers/interfaces/resp-api';

@Injectable({
  providedIn: 'root'
})
export class TiposMedioContactoService {

  urlTiposMedioContacto       = environment.api_base_url + '/tiposMedioContacto';

  public tipoMedioContacto$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public totalTiposMedioContacto$: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  
  constructor(
    private http: HttpClient,
    private auxiliar: AuxiliarService
  ) { }

  set tipoMedioContacto(tipoMedioContacto: TipoMedioContacto) {
    this.tipoMedioContacto$.next(tipoMedioContacto);
  }

  getAll(paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any): Observable<TipoMedioContacto[]> {
    let _filtros = filtros;
    if(!_filtros || _filtros && !filtros?.orden) {
      _filtros = {orden: 'nombre', tipoOrden: 'asc'};
    }
    return this.http.get(`${this.urlTiposMedioContacto}?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(_filtros)}`, {}).pipe(
      tap( (data: RespApi )=> {this.totalTiposMedioContacto$.next( data.total );}),
      map((data: RespApi) => this.mapearTiposMedioContacto( data['data'])) ); 
    // if (paginatorType === TipoPaginadorEnum.offline) {
    //   return this.http.get(this.urlTiposMedioContacto, {}).pipe(
    //     tap(data => console.log('Data: ', data)),
    //     map((data: TipoMedioContacto[]) => data['data']));
    // } else {
    //   return this.http.get(`${this.urlTiposMedioContacto}?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(filtros)}`, {}).pipe(
    //     tap( (data: RespApi )=> {this.totalTiposMedioContacto$.next( data.total );}),
    //     map((data: RespApi) => this.mapearTiposMedioContacto( data['data'])) ); 
    // }
  }

  mapearTiposMedioContacto( tipos: TipoMedioContacto[] ) {
    return tipos;
  }

  get(id): Observable<TipoMedioContacto>{
    return this.http.get(`${this.urlTiposMedioContacto}/${id}`).pipe(
      map((data: RespApi) => data['data'])
    );
  }
}
